var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoundArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 149 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.328 2.629c11.338 16.906 15.6 38.37 9.939 59.498-10.448 38.994-50.74 62.077-89.995 51.559-19.1-5.118-34.437-17.249-43.945-32.849m-5.41 22.906L6.31 79.825a1 1 0 011.177-.884l25.931 4.802",
    stroke: "url(#round-arrow_svg__a)",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "round-arrow_svg__a",
    x1: 3.998,
    y1: 97.205,
    x2: 141.152,
    y2: 107.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4888E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1658BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrow);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQ5IDEyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTMzLjMyOCAyLjYyOWMxMS4zMzggMTYuOTA2MSAxNS42IDM4LjM2OTkgOS45MzkgNTkuNDk4LTEwLjQ0OCAzOC45OTQtNTAuNzQwMyA2Mi4wNzctODkuOTk1IDUxLjU1OS0xOS4xMDA5LTUuMTE4LTM0LjQzNjYtMTcuMjQ4OC00My45NDUwOC0zMi44NDg1TTMuOTE3NDggMTAzLjc0MyA2LjMwOTMgNzkuODI0OGMuMDU4MjMtLjU4MjMuNjAxNzUtLjk5MDQgMS4xNzcxMy0uODgzOGwyNS45MzEwNyA0LjgwMiIgc3Ryb2tlPSJ1cmwoI2EpIiBzdHJva2Utd2lkdGg9IjYiLz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjMuOTk3OTciIHkxPSI5Ny4yMDQ3IiB4Mj0iMTQxLjE1MiIgeTI9IjEwNy4wOSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjNDg4OEU4Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE2NThCQSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };